import { DAPP_UI_VERSION } from "./version";

export type AppLauncherUsageMode = "dapp-ui" | "connect-kit-react";

interface RuntimeLogState {
  mode: AppLauncherUsageMode;
  connectKitVersion?: string;
  scheduled?: boolean;
  loggedMode?: AppLauncherUsageMode;
}

const GLOBAL_KEY = "__nexusCrossAppLauncherRuntime";

function getState(): RuntimeLogState | null {
  if (typeof window === "undefined") return null;
  const global = window as typeof window & {
    [GLOBAL_KEY]?: RuntimeLogState;
  };
  global[GLOBAL_KEY] ??= { mode: "dapp-ui" };
  return global[GLOBAL_KEY];
}

function scheduleFlush(state: RuntimeLogState): void {
  if (state.scheduled) return;
  state.scheduled = true;

  const flush = () => {
    state.scheduled = false;
    if (state.loggedMode === state.mode) return;

    if (state.mode === "connect-kit-react") {
      const kitVersion = state.connectKitVersion ?? "unknown";
      console.info(
        `[CROSSx App Launcher] connect-kit-react v${kitVersion} 초기화 완료 ` +
          `(dapp-ui v${DAPP_UI_VERSION}, 사용 모드: connect-kit)`,
      );
    } else {
      console.info(
        `[CROSSx App Launcher] dapp-ui v${DAPP_UI_VERSION} 초기화 완료 ` +
          `(사용 모드: dapp-ui only)`,
      );
    }

    state.loggedMode = state.mode;
  };

  if (typeof queueMicrotask === "function") {
    queueMicrotask(flush);
  } else {
    Promise.resolve().then(flush);
  }
}

export function announceAppLauncherUsage(options?: {
  mode?: AppLauncherUsageMode;
  connectKitVersion?: string;
}): void {
  const state = getState();
  if (!state) return;

  if (options?.mode === "connect-kit-react") {
    state.mode = "connect-kit-react";
  } else if (!state.mode) {
    state.mode = "dapp-ui";
  }

  if (options?.connectKitVersion) {
    state.connectKitVersion = options.connectKitVersion;
  }

  scheduleFlush(state);
}
